module.exports = __webpack_public_path__ + "img/pv_item.710bf75a.svg";